File.prototype.extension = function () {
    return this.name.split('.').pop();
};
